<script setup lang="ts">
import { RouterView } from 'vue-router';
import AppLayout from '@/components/AppLayout.vue';
</script>

<template>
  <AppLayout>
    <RouterView />
  </AppLayout>
</template>
